import { Reveal } from "../components/Reveal";
import { PageHero, CtaBand } from "../components/ui";
import { ContactForm } from "../components/forms";
import { ADDRESS, ENQUIRY_TYPES, MEDIA_EMAIL } from "../data/site";

export default function Contact() {
    return (
        <>
            <PageHero
                eyebrow="Contact"
                lines={["Let's discuss the infrastructure", "behind Europe's energy transition."]}
                trail={[{ label: "Home", path: "/" }, { label: "Contact" }]}
            />
            <section className="bg-paper">
                <div className="container-x grid gap-14 py-20 sm:py-24 lg:grid-cols-12 lg:py-28">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <h2 className="h3-compact mb-8">Send an enquiry</h2>
                            <ContactForm />
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={0.1}>
                            <div className="border-t-2 border-ink pt-6">
                                <p className="eyebrow">Registered office</p>
                                <address className="mt-6 not-italic font-display text-lg font-medium leading-relaxed text-ink">
                                    {ADDRESS.lines.map((l) => (
                                        <span key={l} className="block">{l}</span>
                                    ))}
                                </address>
                            </div>
                        </Reveal>
                        <Reveal delay={0.15}>
                            <div className="mt-12 border-t-2 border-ink pt-6">
                                <p className="eyebrow">Enquiry types</p>
                                <ul className="mt-6 space-y-3">
                                    {ENQUIRY_TYPES.map((t) => (
                                        <li key={t} className="flex items-baseline gap-4 font-display text-base font-semibold text-ink-2">
                                            <span aria-hidden="true" className="mt-2 block h-px w-5 shrink-0 bg-blue" />
                                            {t}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <div className="mt-12 border-t-2 border-ink pt-6">
                                <p className="eyebrow">Media</p>
                                <p className="body-sm mt-4">
                                    Journalists: please use the{" "}
                                    <a href={`mailto:${MEDIA_EMAIL}`} className="text-blue underline underline-offset-4">
                                        media enquiries
                                    </a>{" "}
                                    channel on the News & Media page.
                                </p>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>
            <CtaBand cta="Email us" />
        </>
    );
}
